
const baseUrl = "/api";
// const baseUrl = "http://localhost:8000";

export default baseUrl;
